"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.princeEdwardIslandCities = void 0;
exports.princeEdwardIslandCities = [
    {
        label: "Albany, PE",
        value: 301,
    },
    {
        label: "Alberton",
        value: 302,
    },
    {
        label: "Belfast",
        value: 303,
    },
    {
        label: "Birch Hill",
        value: 313,
    },
    {
        label: "Bloomfield, PE",
        value: 319,
    },
    {
        label: "Bonshaw",
        value: 315,
    },
    {
        label: "Borden, PE",
        value: 304,
    },
    {
        label: "Breadalbane",
        value: 305,
    },
    {
        label: "Bunbury",
        value: 306,
    },
    {
        label: "Cardigan",
        value: 308,
    },
    {
        label: "Central Bedeque",
        value: 310,
    },
    {
        label: "Charlottetown",
        value: 312,
    },
    {
        label: "Cornwall, PE",
        value: 320,
    },
    {
        label: "Crapaud",
        value: 322,
    },
    {
        label: "French River",
        value: 326,
    },
    {
        label: "Garfield",
        value: 323,
    },
    {
        label: "Georgetown, PE",
        value: 324,
    },
    {
        label: "Hampton",
        value: 318,
    },
    {
        label: "Hunter River, PE",
        value: 307,
    },
    {
        label: "Kensington",
        value: 330,
    },
    {
        label: "Kinkora",
        value: 336,
    },
    {
        label: "Miminigash",
        value: 338,
    },
    {
        label: "Miscouche",
        value: 340,
    },
    {
        label: "Montague",
        value: 342,
    },
    {
        label: "Morell",
        value: 344,
    },
    {
        label: "Mount Stewart",
        value: 346,
    },
    {
        label: "Murray Harbour",
        value: 348,
    },
    {
        label: "Murray River",
        value: 350,
    },
    {
        label: "New Glasgow, PE",
        value: 309,
    },
    {
        label: "North Rustico",
        value: 354,
    },
    {
        label: "O'Leary",
        value: 358,
    },
    {
        label: "Other",
        value: 399,
    },
    {
        label: "Parkdale, PE",
        value: 314,
    },
    {
        label: "Richmond, PE",
        value: 355,
    },
    {
        label: "Rosebank",
        value: 317,
    },
    {
        label: "Sherwood, PE",
        value: 316,
    },
    {
        label: "Slemon Park",
        value: 328,
    },
    {
        label: "Souris, PE",
        value: 360,
    },
    {
        label: "South Port",
        value: 361,
    },
    {
        label: "St Eleanor's",
        value: 362,
    },
    {
        label: "St Louis, PE",
        value: 364,
    },
    {
        label: "St. Peters Bay",
        value: 368,
    },
    {
        label: "Stratford",
        value: 311,
    },
    {
        label: "Summerside",
        value: 374,
    },
    {
        label: "Tignish",
        value: 376,
    },
    {
        label: "Tyne Valley",
        value: 378,
    },
    {
        label: "Victoria, PE",
        value: 382,
    },
    {
        label: "Wellington, PE",
        value: 386,
    },
    {
        label: "Wilmot, PE",
        value: 388,
    },
    {
        label: "Winsloe",
        value: 390,
    },
];
